import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AccountPropertyCheckParams } from '~core/models/account.models';
import { ApiConstantsService } from '../../../../../../libs/~core/src/lib/services/api-constants.service';
import { User, UserCreationParams } from '~core/models/auth.models';
import { environment } from '~environments/environment';
import { ROUTES } from '~backoffice/app/~shared/constants/routes.constants';

@Injectable()
export class AccountService {
  private _http = inject(HttpClient);
  private _apiConstantsService = inject(ApiConstantsService);

  checkUserPropertyValidity(
    params: AccountPropertyCheckParams
  ): Observable<unknown> {
    return this._http.post<unknown>(
      `${this._apiConstantsService.accountUrl}/check`,
      params
    );
  }

  create(data: UserCreationParams, otp?: string): Observable<User> {
    return this._http.post<User>(
      this._apiConstantsService.accountUrl,
      {
        ...data,
        redirectUrl: `${environment.redirectUrl}${ROUTES.login}`,
        useStateFormViolationHandler: true
      },
      {
        headers: {
          authorization: `Otp ${otp}`
        }
      }
    );
  }
}
